import { render } from "./AcreditadoSection.vue?vue&type=template&id=45375f4b&ts=true"
import script from "./AcreditadoSection.vue?vue&type=script&lang=ts"
export * from "./AcreditadoSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__